import { brandSpecificStaticText, staticText } from 'utils/staticText';

const base = staticText({
  breadcrumbs_home: {
    _: 'Home',
    zh: '首頁',
  },
  breadcrumbs_personal_loans: {
    _: 'Personal Loans',
    zh: '私人貸款',
  },
  breadcrumbs_credit_cards: {
    _: 'Credit Cards',
    zh: '信用卡',
  },
  breadcrumbs_travel_insurance: {
    _: 'Travel Insurance',
    zh: '旅遊保險',
  },
  breadcrumbs_investment: {
    _: 'Investments',
  },
  breadcrumbs_banking: {
    _: 'Banking',
  },
  breadcrumbs_blog: {
    _: 'Blog',
    zh: '部落格',
  },
  breadcrumb_start: {
    _: 'Start',
    zh: '開始',
  },
});

export const BREADCRUMB_TRANSLATIONS = brandSpecificStaticText({
  _: base,
  money101: staticText({
    breadcrumbs_personal_loans: {
      _: 'Personal Loans',
      zh: '貸款',
    },
    breadcrumbs_credit_cards: {
      _: 'Credit Cards',
      zh: '信用卡',
    },
    breadcrumbs_investment: {
      _: 'Investments',
      zh: '證券開戶',
    },
    breadcrumbs_banking: {
      _: 'Banking',
      zh: '銀行帳戶',
    },
  }),
});
